<template>
  <div class="app-main-content vehicle-lookup">
    <h1>Look up your vehicle registration status</h1>
    <p>
      Check the current status of your Vehicle Registration on record with the State of Rhode Island Division
      of Motor Vehicles.
    </p>

    <LookupForm />
  </div>
</template>

<script>
import appConfig from '@/app.config'
import LookupForm from '@/components/modules/vehicle/LookupForm'


export default {
  name: 'VehicleLookup',
  page: {
    title: `Vehicle Registration Status Lookup | ${appConfig.shortName}`,
    meta: [
      {
        name: 'description',
        content: 'Check the current registration status of your vehicle on record with the DMV.'
      }
    ]
  },
  components: {
    LookupForm,
  },
}
</script>

